import { api } from '@/lib/api';

export interface QuizData {
  id: string;
  paragraph: string;
  answer: string[];
  totalBlanks: number;
  words: Record<string, {
    data: Array<{
      word: string;
      phonetic?: string;
      phonetics?: Array<{
        text: string;
        audio?: string;
        license?: {
          name: string;
          url: string;
        };
        sourceUrl?: string;
      }>;
      meanings: Array<{
        partOfSpeech: string;
        definitions: Array<{
          definition: string;
          example?: string;
          synonyms?: string[];
          antonyms?: string[];
        }>;
        synonyms?: string[];
        antonyms?: string[];
      }>;
      license?: {
        name: string;
        url: string;
      };
      sourceUrls?: string[];
    }>;
  }>;
}

export interface QuizResponse {
  ok: boolean;
  data?: QuizData;
}

export async function generateQuiz(words: string[]): Promise<QuizResponse> {
  try {
    const response = await api.post<QuizResponse>('/practice/fill_in_the_blank', {
      words,
    });

    return response;
  } catch (error) {
    console.error('Failed to generate quiz:', error);
    // For API errors, return a response with ok: false
    return {
      ok: false,
      data: undefined,
    };
  }
}

export async function getQuizById(id: string): Promise<QuizResponse> {
  try {
    const response = await api.get<QuizResponse>(`/practice/fill_in_the_blank/${id}`);
    return response;
  } catch (error) {
    console.error('Failed to get quiz by ID:', error);
    return {
      ok: false,
      data: undefined,
    };
  }
}

export interface QuizCompletionResponse {
  ok: boolean;
  data?: {
    id: string;
    is_completed: boolean;
    message: string;
  };
}

export async function markQuizCompleted(id: string): Promise<QuizCompletionResponse> {
  try {
    const response = await api.put<QuizCompletionResponse>(`/practice/fill_in_the_blank/${id}`, {
      is_completed: true,
    });
    return response;
  } catch (error) {
    console.error('Failed to mark quiz as completed:', error);
    return {
      ok: false,
      data: undefined,
    };
  }
}